import React from 'react';
import { StatusIcon } from '@nicheinc/campus-ds';
import { type StatusIconProps } from '@nicheinc/campus-ds/atoms';

import { TableMapperType } from '../../types';

type PropsType = {
	mapperField: TableMapperType;
	item: any;
};

function StatusIconCell({ mapperField, item }: PropsType) {
	const statusIconVariant =
		typeof mapperField.statusIconVariant === 'function'
			? mapperField.statusIconVariant(item)
			: mapperField.statusIconVariant;

	return (
		<StatusIcon
			variant={statusIconVariant as StatusIconProps['variant']}
			size="small"
		/>
	);
}

export default StatusIconCell;
